module.exports = "<ul class=\"pagination no-margin\"> <li class=btn-page :class=\"{'disabled': model.page() == 1}\"> <a href=javascript:; @click=previous()><img src=" + require("../../static/ic_keyboard_arrow_left.svg") + " alt=\"\"></a></li> <li class=btn-page :class=\"{'disabled': model.page() == model.pageCount()}\"> <a href=javascript:; @click=next()><img src=" + require("../../static/ic_keyboard_arrow_right.svg") + " alt=\"\"></a> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/pagination-sm.html
// module id = 1690
// module chunks = 1